export const createGridTabsCss = ({ customClassName, overrideCss, active, disabled, } = {}) => {
    const gridTabCss = [];
    const gridTabsContainerCss = [];
    const gridTabItemCss = [];
    const gridTabItemTextCss = [];
    const gridTabsLabel = [];
    if (!overrideCss) {
        gridTabCss.push('grid-tab');
        gridTabsContainerCss.push('grid-tab__container');
        gridTabItemCss.push('grid-tab-item');
        gridTabItemTextCss.push('grid-tab-item__text');
        gridTabsLabel.push('grid-tabs__label');
    }
    if (customClassName) {
        gridTabCss.push(`${customClassName}`);
        gridTabsContainerCss.push(`${customClassName}__container`);
        gridTabItemCss.push(`${customClassName}-item`);
        gridTabItemTextCss.push(`${customClassName}-item__text`);
    }
    if (active) {
        if (!overrideCss) {
            gridTabItemCss.push('grid-tab-item--active');
        }
        if (customClassName) {
            gridTabItemCss.push(`${customClassName}-item--active`);
        }
    }
    if (disabled) {
        if (!overrideCss) {
            gridTabItemCss.push('grid-tab-item--disabled');
            gridTabItemTextCss.push('grid-tab-item__text--disabled');
        }
        if (customClassName) {
            gridTabItemCss.push(`${customClassName}-item--disabled`);
            gridTabItemTextCss.push(`${customClassName}-item__text--disabled`);
        }
    }
    return {
        gridTabsCss: gridTabCss.join(' '),
        gridTabsContainerCss: gridTabsContainerCss.join(' '),
        gridTabItemCss: gridTabItemCss.join(' '),
        gridTabItemTextCss: gridTabItemTextCss.join(' '),
        gridTabsLabel: gridTabsLabel.join(' '),
    };
};
//# sourceMappingURL=createGridTabsCss.js.map